import { useSelector } from 'react-redux';
import { TextKey } from '@mews-commander/enums';
import { Typography } from '@optimus-web/core';
import { MEWS_CAPITAL_DISCLAIMER, useLocalizeText } from '@mews/framework';
import { TextWithLinks } from '@mews-commander/ui';
import { getCurrentEnterpriseCountryCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { getPlatformPrimaryUrl } from '../../../app/reducers/configuration';

export const ConsentText = () => {
    const localizeText = useLocalizeText();
    const platformPrimaryUrl = useSelector(getPlatformPrimaryUrl);
    const enterpriseCountryCode: string = useCommanderSelector(getCurrentEnterpriseCountryCode);

    return (
        <Typography textStyle="bodySmall" variant="secondary" as="div">
            <TextWithLinks
                links={[
                    {
                        id: 'importantInfo',
                        url: `${platformPrimaryUrl}${MEWS_CAPITAL_DISCLAIMER}?countryCode=${enterpriseCountryCode}`,
                        text: localizeText({ textKey: TextKey.FinancialServicesCapitalImportantInformation }),
                    },
                ]}
                text={localizeText({ textKey: TextKey.FinancialServicesCapitalConsentText })}
            />
        </Typography>
    );
};
